import { Injectable } from '@angular/core';
import { catchError, take, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { HttpService } from '../http.service';
import { UserService } from '../shared/user.service';
import { StorageService } from '../storage.service';
import { ClientDetailsResponse } from 'src/app/account/my-account/model/agentDetailsResponse.model';
import { OpportunityCampaignContactRequest } from 'src/app/lp/models/OpportunityCampaignContactRequest.model';
import { PersonalDetailsReqRes } from 'src/app/account/models/personalDetailsReqRes.model';

@Injectable()
export class LpUserDataService {

  private ACCOUNT_ENDPOINT = 'account';
  private SWITCH_TO_ORGANIZATION_ENDPOINT = this.ACCOUNT_ENDPOINT + '/lp/switchIndividualToOrg';
  private SWITCH_TO_INDIVIDUAL_ENDPOINT = this.ACCOUNT_ENDPOINT + '/lp/switchOrgToIndividual';

  constructor(private http: HttpService, 
    private userService: UserService,
    private storageService: StorageService) { }


  switchToOrganization() {
    return this.http.post(this.SWITCH_TO_ORGANIZATION_ENDPOINT, {}).pipe(
      tap(() => {
        this.userService.refreshedClientDetails$.next(null);
      }),
      catchError(err => {
        return throwError(()=>err);
      })
    );
  }

  switchToIndividual() {
    return this.http.post(this.SWITCH_TO_INDIVIDUAL_ENDPOINT, {}).pipe(
      tap(() => {
        this.userService.refreshedClientDetails$.next(null);
      }),
      catchError(err => {
        return throwError(()=>err);
      })
    );
  }

  
  
  createOpportunityCampaignContact(clientDetails:ClientDetailsResponse){
    const gpRefKey = this.storageService.getGpReferralKeyDataFromStorage();
    
    if(!gpRefKey){
      return;
    }

    const gpRefKeys = this.storageService.getAllGpReferralKeysDataFromStorage();

    if(!!gpRefKeys && gpRefKeys.some(ref => ref === gpRefKey)){
      return;
    }

    if(!clientDetails || !clientDetails.firstName || !clientDetails.lastName 
      || !clientDetails.phone1 || !clientDetails.locationDetails?.countryId){
        return
    }

    const investorContact = new OpportunityCampaignContactRequest();
    investorContact.personalDetailsRequest = new PersonalDetailsReqRes();
    investorContact.personalDetailsRequest.email = clientDetails.email;
    investorContact.personalDetailsRequest.firstName = clientDetails.firstName;
    investorContact.personalDetailsRequest.lastName = clientDetails.lastName;
    investorContact.personalDetailsRequest.phone1 = clientDetails.phone1;
    investorContact.personalDetailsRequest.countryId = clientDetails.locationDetails.countryId;

    investorContact.tags = this.storageService.getAllOpportunityTagsDataFromStorage() || [];

    this.storageService.removeAllOpportunityTagsFromStorage();

    this.http.postTyped<void>(`lp/opportunity/campaignContact/${gpRefKey}`, investorContact).pipe(
      take(1)
    )
    .subscribe(_ => this.storageService.updateGpReferralKeysDataInStorage(gpRefKey));
  }

}
